import {ChangeDetectionStrategy, Component, computed, input, OnInit, output, signal, ViewChild} from '@angular/core';
import {ModalCommand} from '../../../types/ModalCommand';
import {ModalTypeEnum} from '../../../enums/ModalEnums';
import {ModalsControlService} from '../../../services/modals-control.service';
import {ToolsService} from '../../../services/tools.service';
import {CareproviderMapItemTranslated} from '../../../types/CareproviderMapItemTranslated';
import {AppConfigService} from '../../../services/app-config.service';
import {CareproviderAddress} from '../../../types/CareproviderAddress';
import {UiButtonComponent} from '../../ui/ui-button/ui-button.component';
import {UiIconButtonComponent} from '../../ui/ui-icon-button/ui-icon-button.component';

@Component({
  selector: 'app-google-map-quick-loader-v2',
  templateUrl: './google-map-quick-loader-v2.component.html',
  styleUrls: ['./google-map-quick-loader-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoogleMapQuickLoaderV2Component implements OnInit {
  public size = input<'xs' | 'sm' | 'md' | 'lg'>(null);
  public expanded = input<'inline' | 'block' | 'pill'>(null);
  public color = input<
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'green'
    | 'lightgreen'
    | 'apricot'
    | 'flat'
    | 'ghost'
    | 'outline-tertiary-green'
  >(null);
  public addBackgroundMap = input<boolean>(false);
  public useStaticData = input<boolean>(false);

  public address = input<CareproviderAddress>(null);
  public id = input<number>(null);
  public name = input<string>(null);
  public urlPath = input<string>(null);
  public imageUrl = input<string>(null);

  public iconOnly = input<boolean>(false);
  public iconButtonSize = computed<'md' | 'lg'>(() => (this.size() === 'xs' ? 'md' : 'lg') as 'md' | 'lg');
  public iconButtonColor = computed<'primary' | 'transparent'>(() => {
    if (this.color() === 'primary') {
      return 'primary';
    }
    return 'transparent';
  });

  public mapModalOpen = output<boolean>();
  public mapModalClose = output<boolean>();

  public markers = signal<CareproviderMapItemTranslated[]>([]);
  public mapUrl = signal<string>(null);

  @ViewChild('openMapButtonWithMap') mapButtonWithMap: UiButtonComponent;
  @ViewChild('openMapButtonWithMapIconOnly') mapButtonWithMapIconOnly: UiIconButtonComponent;
  @ViewChild('openMapButtonWithoutMap') mapButtonWithoutMap: UiButtonComponent;
  @ViewChild('openMapButtonWithoutMapIconOnly') mapButtonWithoutMapIconOnly: UiButtonComponent;

  constructor(
    private tools: ToolsService,
    private modalControl: ModalsControlService,
    private appConfigService: AppConfigService,
  ) {
    this.mapUrl.set(`${appConfigService.appConfig.amazonS3Url}assets/map-quick-loader-button-bg.jpg`);
  }

  ngOnInit() {
    if (this.useStaticData() === true) {
      this.initStaticMap();
    }
  }

  public processClick() {
    this.mapModalOpen.emit(true);
    this.openModal();
  }

  private openModal(): void {
    const callback = () => {
      this.mapModalClose.emit(true);
    };
    const modalCommand: ModalCommand = {
      type: ModalTypeEnum.GOOGLE_MAP,
      data: {height: 80, markers: this.markers(), callback: callback},
    };
    this.modalControl.openModal(modalCommand);
  }

  private initStaticMap(): void {
    if (!this.tools.isNil(this.id())) {
      this.loadCareproviderUnitMarker();
    }
  }

  private loadCareproviderUnitMarker(): void {
    const marker: CareproviderMapItemTranslated = {
      id: this.id(),
      name: this.name(),
      urlPath: this.urlPath(),
      location: {
        lat: this.address()?.latitude,
        lng: this.address()?.longitude,
      },
      rating: 0,
      address: this.address(),
      thumbnail: this.imageUrl(),
    };
    this.markers.update((markers) => [...markers, marker]);
  }
}
